/*
 * @Author: 曹捷
 * @Date: 2021-02-04 11:59:02
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-28 10:25:17
 * @Description: 调用API
 */
import { API } from 'obit-wui'
const modulesFiles = require.context("./apis", true, /\.js$/);
import { name } from './../../package.json'
export default function (router) {
  let ajaxInfo = new API({
    modules: [],
    successCode: 200,
    // beforeRequest (config) {
    //   let user = userRole.get()
    //   console.log('🚀 ~ file: index.js ~ line 18 ~ beforeRequest ~ user', user)
    //   return config
    // },
    router
  }, name)
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath);
    return Object.assign(modules, value.default(ajaxInfo.api, name));
  }, {});
  ajaxInfo.init(modules)
  return {
    item: ajaxInfo,
    methods: ajaxInfo.methods,
    API: ajaxInfo.API
  }
}

